import React from 'react';

import Framework from "@beardeddevops/react.framework";
import ScheduleOptimizationsContainer from "../../../../../components/Containers/ScheduleOptimizations";
import Tickers from "../../../../../components/Parts/Tickers";

const breadcrumbStatic = [{
	name: 'Managers',
	url: '/managers',
	icon: 'dashboard'
}];

export default class ScheduleOptimizations extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				{/*<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>*/}

				<ScheduleOptimizationsContainer history={history} />

			</div>
		)
	}
}